var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPythonOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2C18,7.9,18.9,7,20,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,39c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2C28,39.9,28.9,39,30,39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#555555",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M25,3c-7.8,0-10,3.7-10,6.1V13h10v3H9.1C6,16,3,18.6,3,25s3,9,6.1,9H15v-5c0-2.2,1.8-4,4-4l12,0c2.2,0,4-1.8,4-4V9.1C35,6.6,32.8,3,25,3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#555555",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M25,47c7.8,0,10-3.7,10-6.1V37H25v-3h15.9c3.1,0,6.1-2.6,6.1-9s-3-9-6.1-9H35v5c0,2.2-1.8,4-4,4l-12,0c-2.2,0-4,1.8-4,4v11.9C15,43.3,17.2,47,25,47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonOutline);
export default __webpack_public_path__ + "static/media/python_outline.239a756bce7e7d03641bef59e3615bb4.svg";
export { ForwardRef as ReactComponent };